/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import { updatePaymentUsedToPlaceOrder } from './OrderPlacedPayment-Actions';

const initialState = {};

export const orderPlacedPayment = (state = initialState, action) => {
    switch (action.type) {
        case updatePaymentUsedToPlaceOrder().type:
            return { ...state, ...action.data };
        default:
            return state;
    }
};

export default {};
